var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"ingredients-list"}},[_c('button',{attrs:{"id":"search-button","disabled":_vm.disabled},on:{"click":_vm.search}},[_vm._v("\n    Search\n  ")]),_vm._v(" "),_c('ul',{class:{active: !_vm.disabled}},_vm._l((_vm.itemList),function(itemName,index){return _c('li',{key:index},[_c('p',[_vm._v(_vm._s(itemName))]),_vm._v(" "),_c('i',{staticClass:"delete fa fa-times",on:{"click":function($event){_vm.removeItem(index)}}})])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1152f177","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ingredients-list.vue
// module id = 30
// module chunks = 0